export { AndarBahar as AndarBaharIcon } from './AndarBahar';
export { Baccarat as BaccaratIcon } from './Baccarat';
export { Blackjack as BlackjackIcon } from './Blackjack';
export { DragonTiger as DragonTigerIcon } from './DragonTiger';
export { PokDeng as PokDengIcon } from './PokDeng';
export { Roulette as RouletteIcon } from './Roulette';
export { SeDie as SeDieIcon } from './SeDie';
export { Sicbo as SicboIcon } from './Sicbo';
export { TeenPatti2020 as TeenPatti2020Icon } from './TeenPatti2020';
